import { render, staticRenderFns } from "./GradStories.vue?vue&type=template&id=5147bf66&"
import script from "./GradStories.vue?vue&type=script&lang=js&"
export * from "./GradStories.vue?vue&type=script&lang=js&"
import style0 from "./GradStories.vue?vue&type=style&index=0&id=5147bf66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardsGraduateCard: require('/opt/build/repo/components/Cards/GraduateCard.vue').default,CardsGraduateCardNew: require('/opt/build/repo/components/Cards/GraduateCardNew.vue').default})
